import { render, staticRenderFns } from "./redirect-timer.vue?vue&type=template&id=d8ca5578&scoped=true&"
import script from "./redirect-timer.vue?vue&type=script&lang=js&"
export * from "./redirect-timer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ca5578",
  null
  
)

export default component.exports